import axios from "axios";
import { Auth } from "aws-amplify";
import { parseJwt } from "@/utils";
const BASE_URL = import.meta.env.VITE_API_BASE_URL;
let refreshPromise = null;

axios.interceptors.request.use(
  async (config) => {
    let session;
    try {
      session = await Auth.currentSession();
    } catch {
      let customToken = localStorage.getItem("sso-authToken");

      if (customToken && customToken !== 'null') {
        const payload = parseJwt(customToken);
        const currentTime = Math.floor(Date.now() / 1000);
        const gracePeriod = 60;

        if (payload && payload.exp < currentTime + gracePeriod) {
          if (!refreshPromise) {
            const refreshAxios = axios.create();
            refreshPromise = refreshAxios.post(
              `${BASE_URL}/authentication/renew_access_token`,
              {},
              {
                headers: {
                  Authorization: `Bearer ${customToken}`,
                },
              }
            )
              .then(res => {
                const newToken = res.data?.access_token || customToken;
                localStorage.setItem("sso-authToken", newToken);
                window.dispatchEvent(new Event("storage"));
                return newToken;
              })
              .catch(() => customToken)
              .finally(() => { refreshPromise = null; });
          }
          customToken = await refreshPromise;
        }

        config.headers.Authorization = `Bearer ${customToken}`;
      }

      return config;
    }
    const authTokenExpiration = session.getIdToken().getExpiration(),
      refreshToken = session.getRefreshToken(),
      currentTimeSeconds = Math.round(+new Date() / 1000);

    if (authTokenExpiration < currentTimeSeconds) {
      const user = await Auth.currentAuthenticatedUser();

      user.refreshSession(refreshToken, (error, data) => {
        if (error) {
          // remove authToken from storage, dispatch event
          localStorage.setItem("decoder-authToken", null);
          window.dispatchEvent(new Event("storage"));
        } else {
          let newToken = data.getIdToken().getJwtToken();

          // add new authToken from storage, dispatch event
          localStorage.setItem("decoder-authToken", newToken);
          window.dispatchEvent(new Event("storage"));

          config.headers.Authorization = `Bearer ${newToken}`;
          return config;
        }
      });
    } else {
      let token = session.getIdToken().getJwtToken();
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    }
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let status = error.response?.status;

    if (![401, 403].includes(status)) return Promise.reject(error);

    // handle 401 and 403's by unsetting the token in local storage, effectively logging the user out.
    localStorage.setItem("decoder-authToken", null);
    window.dispatchEvent(new Event("storage"));

    return Promise.reject(error);
  }
);

export default axios;
